<template>
    <div id="hvut_invoice_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="invoiceHeader" v-if="$route.params.id > 0">Update Customer Invoice</span>
                    <span class="page-title" id="invoiceHeader" v-else>Add Customer Invoice</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackInvoiceList"  >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content hvut-invoice-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="HVUTInvoiceForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label" for="invoice_number">Invoice #: </label>
                                        <span class="label font-semibold">{{invoice_number}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_id">Customer:</label>
                                        <span class="label font-semibold">{{customer}}</span>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Customer Email:</label>
                                        <input type="text" class="form-control" v-model="emails" id="emails" placeholder="Enter Emails" name="emails">
                                        <div class="field-error">{{emails_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="term_id">Term:</label>
                                        <v-select v-model="term_id" name="term_id" placeholder="Select Term" label="text" :options="termsArr" :disabled="disableAll" @input="onTermChange($event)">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Invoice Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="invoice_date" name="invoice_date" v-model="invoice_date" :config="optionsDate" aria-describedby="basic-addon3" :disabled="disableAll" @dp-change="onInvDateChange"></date-picker>
                                            <label for="invoice_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{invoice_date_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require">Due Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="due_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{due_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="invoice_type_id">Invoice Type:</label>
                                        <v-select v-model="invoice_type_id" name="invoice_type_id" placeholder="Select Invoice Type" label="text" class='close-remove' :options="invoiceTypesArr" :disabled="disableField">
                                        </v-select>
                                        <div class="field-error">{{invoice_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">Location:</label>
                                        <v-select v-model="location" name="location_id" placeholder="Select Location." label="text" :options="locationArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="state">Reason:</label>
                                        <v-select v-model="reason_id" name="reason_id" placeholder="Select reason." label="text" :options="reasonArr" :disabled="disableAll">
                                        </v-select>
                                        <!-- <div class="field-error">{{reason_error_msg}}</div> -->
                                    </div>
                                </div>
                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="table-responsive-sm mt-4">
                                    <table aria-describedby="table" class="table table-sm">
                                        <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Unit Number</th>
                                            <th scope="col" class="require" style="width:350px">GL Account</th>
                                            <th scope="col" class="require">Description</th>
                                            <th scope="col" class="text-right">Gross Weight</th>
                                            <th scope="col" class="require text-center">Effective Date</th>
                                            <th scope="col" class="require">Expiry Date</th>
                                            <th scope="col" class="require text-right">Amount</th>
                                            <th scope="col" class="require text-right" v-if="isCredit">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <span class="label">{{row.unit_no}}</span>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.account" name="account" id="account"
                                                                label="text" :filterable="false" :options="accountsArr"
                                                                @search="onSearchAccount"
                                                                placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                        Search Account...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.account_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Description"  v-model="row.description" id="description" name="description" class="vgt-input">
                                                    <div class="field-error">{{row.description_error_msg}}</div>
                                                </td>
                                                <td class="text-right">
                                                    <span class="label">{{row.gross_weight}}</span>
                                                </td>
                                                <td class="text-center">
                                                    <span class="label">{{row.effective_date}}</span>                                                                
                                                </td>
                                                <td>
                                                    <span class="label">{{row.expiry_date}}</span>                                                                
                                                </td>
                                                <!-- <td class="text-right">
                                                    <span class="label">{{amountFormat(row.amount)}}</span>
                                                </td> -->
                                                <td v-if="isCredit">
                                                    <input type="text" placeholder="Amount" v-model="row.amount"
                                                    @keypress="isNumberCheck($event,index, 'amount')" @input="calculateTotal($event,index)" name="amount" class="vgt-input text-right" >
                                                    <!-- <div class="field-error">{{row.unit_price_error_msg}}</div> -->
                                                </td>
                                                <td class="text-right" v-else>
                                                    <span class="label">{{amountFormat(row.amount)}}</span>
                                                </td>
                                                 <td class="text-center valign-middle" v-if="isCredit">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>    
                                        </tbody>    
                                    </table>    
                                </div>    
                                        <template v-if="showTotalSummary">
                                            <div class="order-summary mt-4">
                                                <div class="row">
                                                    <div class="col-md-6 offset-md-6">
                                                        <div class="bg-white radius-5 p-3">
                                                            <label class="font-bold"> SUMMARY </label>
                                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                                <tr class="table-secondary">
                                                                    <td>Total Before Tax:</td>
                                                                    <td class="text-right">${{sub_total.toFixed(2)}}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total Taxes:</td>
                                                                    <td class="text-right">${{total_tax.toFixed(2)}}</td>
                                                                </tr>
                                                                <tr class="table-secondary">
                                                                    <td>Total:</td>
                                                                    <td class="order-total text-right">${{total.toFixed(2)}}</td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="form-group">
                                            <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="field-error"></strong>
                                            </div>
                                        </div>    
                                        <div class="btn-groups">
                                            <button type="submit" id="CreatePermitInvoiceBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateHVUTInvoice('Update')" >
                                            <i class="fp-reload"> </i>  Update
                                            </button>
                                            <button type="submit" id="CreatePermitInvoiceBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateHVUTInvoice('Save')" >
                                            <i class="fp-save"> </i>  Save
                                            </button>
                                            
                                            <button type="submit" id="cancelPermitInvoiceBtn" class="btn btn-tertiary" v-on:click.prevent="BackInvoiceList" >
                                            <i class="fp-close"> </i>  Cancel
                                            </button>
                                        </div>
                            </form>    
                        </section>
                    </div>
                </div>    
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
export default {
    name:"HvutInvoiceCreate",
    metaInfo() {
        return {
            title: (this.$route.query.hvut_id != undefined)? "Create Customer Invoice | " +process.env.COPYRIGHT_NAME : "Update Customer Invoice | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        processed_hvut_schedule_id:0,
        hvut_id:0,
        invoiceId:0,
        invoice_number:"",
        customer_id:"",
        customer:"",        
        term_id:"",
        termsArr:[],
        invoice_date:"",
        due_date:"",
        invoice_type_id:"",
        invoiceTypesArr:[],
        unit_no:"",
        gross_weight:"",
        rows:[],
        sub_total:0,
        total_tax:0,
        total:0,
        invoice_date_error_msg:"",
        due_date_error_msg:"",
        invoice_type_error_msg:"",
        common_error_msg:"",
        location_id:"",
        disableField:false,
        showTotalSummary:false,
        emails_error_msg:'',
        emails:'',
        accountsArr:[],
        location:'',
        locationArr:[],
        reasonArr:[],
        reason_id : "",
        reason_error_msg : "",
        isCredit:false,
        disableAll:false,
    }),
    watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_invoice') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        sub_total:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;

        },        
        total_tax:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;
        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['invoiceTypes','terms','location','reason']);
        
        var path = window.location.pathname;
        var segments = path.split("/");
        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            self.invoiceId = self.$route.query.inv_id;
            self.loadHVUTInvoice();
        }else
        if (self.$route.query.hvut_id != undefined) {
            self.processed_hvut_schedule_id = self.$route.query.hvut_id;    
            console.log(self.processed_hvut_schedule_id);
            self.loadHVUTInvoiceData();
        }else{
            console.log(segments[4]);
            self.invoiceId = this.$route.params.id;
            self.loadHVUTInvoice();
        }
        var todayDate = self.getTodayDate();
        self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
   
        if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
            self.isCredit = true;
        }
    },
    methods: {
        BackInvoiceList() {
            var self = this;
            self.$router.push("/invoice/list");
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                if (self.location_id != null && self.location_id > 0){
                    
                    self.searchField(loading, search, 'accounts', self.location_id);

                }else{
                    
                    self.searchField(loading, search, 'accounts', '');

                }
            }
        },
        CreateHVUTInvoice(flag) {
            var self = this;
            var error = false;
            self.invoice_date_error_msg = "";
            self.due_date_error_msg = "";
            self.invoice_type_error_msg = "";
            self.common_error_msg = "";
            self.emails_error_msg = "";

            if (!self.invoice_date || self.invoice_date == null || self.invoice_date == "") {
                self.invoice_date_error_msg = "Invoice Date Required.";
                error = true;
            }

            if (!self.emails || self.emails == null || self.emails == "") {
                self.emails_error_msg = "Emails Required.";
                error = true;
            }

            if (self.emails.includes(',')){
                var emails = self.emails.split(',');

                if (emails.length > 0){
                    for( var i=0;i < emails.length;i++){
                        if (!self.validEmail(emails[i])){
                            self.emails_error_msg = 'Please enter valid email';
                            error = true;
                        }
                    }
                }
            }else{
                if (self.emails != '' && !self.validEmail(self.emails)){
                    self.emails_error_msg = 'Please enter valid email';
                    error = true;
                }
            }

            if (!self.due_date || self.due_date == null || self.due_date == "") {
                self.due_date_error_msg = "Due Date Required.";
                error = true;
            }

            if ( self.invoice_type_id == null || self.invoice_type_id.value == "") {
                self.invoice_type_error_msg = "Invoice Type Required.";
                error = true;
            }

            // if ( self.reason_id == null || self.reason_id == "" ) {
            //     self.reason_error_msg = "Reason Required.";
            //     error = true;
            // }

            for (var i = 0; i < self.rows.length; i++) {

                self.rows[i].description_error_msg = "";
                self.rows[i].account_error_msg = "";

                if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                    self.rows[i].description_error_msg = "Description Required.";
                    error = true;
                }

                if ( self.rows[i].account == null || self.rows[i].account == "" ) {
                    self.rows[i].account_error_msg = "GL Account Required.";
                    error = true;
                }
            }

            if (self.rows.length < 1) {
                error = true;
                self.common_error_msg = "No Line Item Found. Invoice cannot be generated."
            }

            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = $("#HVUTInvoiceForm").serializeArray();

                if (segments[4])
                {
                    $("#CreatePermitInvoiceBtn").val("Updating ...");
                    $("#CreatePermitInvoiceBtn").prop("disabled", true);
                    $("#cancelPermitInvoiceBtn").prop("disabled",true);

                } else {

                    if (flag == "Save and Continue") {

                        $("#CreatePermitInvoiceBtn").prop("disabled", true);
                        $("#cancelPermitInvoiceBtn").prop("disabled",true);

                    } else{

                        $("#CreatePermitInvoiceBtn").val("Saving ...");
                        $("#CreatePermitInvoiceBtn").prop("disabled", true);
                        $("#cancelPermitInvoiceBtn").prop("disabled",true);
                    }
                }

                // fields.push({name: "customer_id", value: self.customer_id});
                fields.push({name: "processed_hvut_schedule_id", value: self.processed_hvut_schedule_id});

                if (self.invoice_type_id == null || self.invoice_type_id.value == "") {
                    fields.push({name: "invoice_type_id", value: ""});
                } else{
                    fields.push({name: "invoice_type_id", value: self.invoice_type_id.value});
                }

                if (self.term_id == null || self.term_id == "") {
                    fields.push({name: "term", value: ""});
                } else{
                    fields.push({name: "term", value: self.term_id.value});
                }
                fields.push({name: "location_id", value: self.location_id});

                
                fields.push({name:"reason_id",value: self.reason_id.value});
                fields.push({name:"parent_id",value:  self.$route.query.inv_id});

                // fields.push({name: "sub_total", value: self.sub_total});               
                // fields.push({name: "tax_amount", value: self.total_tax});
                // fields.push({name: "total", value: self.total});

                if (!self.rows[0]) {      
                    self.rows = [];
                }
                //description and invoice_item_id as parameters
                var invItems = [];
                if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
                    for (var i = 0; i < self.rows.length; i++) {
                        invItems.push({
                            invoice_item_id:0,
                            description:self.rows[i].description,
                            account:self.rows[i].account.value,
                            amount:self.rows[i].amount
                        });
                    }
                    fields.push({ name: "flag", value: "hvut_credit_invoice" });
                }else{
                    for (var i = 0; i < self.rows.length; i++) {
                        invItems.push({
                            invoice_item_id:self.rows[i].invoice_item_id,
                            description:self.rows[i].description,
                            account:self.rows[i].account.value
                        });
                    }
                    fields.push({ name: "flag", value: "store" });
                }
               
                fields.push({name: "invoiceItems", value: JSON.stringify(invItems)});
                fields.push({ name: "id", value: segments[4] });
                console.log(fields);

                $.ajax({
                    url: process.env.ROOT_API + "/invoice/hvut/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (segments[4])
                        {
                            $("#CreatePermitInvoiceBtn").val("Update");
                            $("#CreatePermitInvoiceBtn").prop("disabled", false);
                            $("#cancelPermitInvoiceBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#CreatePermitInvoiceBtn").prop("disabled", false);
                                $("#cancelPermitInvoiceBtn").prop("disabled",false);

                            } else{

                                $("#CreatePermitInvoiceBtn").val("Save");
                                $("#CreatePermitInvoiceBtn").prop("disabled", false);
                                $("#cancelPermitInvoiceBtn").prop("disabled",false);

                            }
                        }                        
                        
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {
                                
                                $("#permitInvoiceForm").trigger("reset");
                                self.term_id = "";
                                self.invoice_type = null;    
                                self.emails = '';      
                                self.rows=[];
                                self.rows.push({
                                    invoice_item_id:0,
                                    process_hvut_schedule_id:self.processed_hvut_schedule_id,
                                    unit_no:self.unit_no,
                                    hvut_id:self.hvut_id,
                                    gross_weight:self.gross_weight,
                                    description:"",
                                    effective_date:"",
                                    expiry_date:"",
                                    amount:0,
                                    description_error_msg:"",
                                    account:"",
                                    account_error_msg:"",
                                });                           
                                
                                
                                self.sub_total = 0;
                                self.sub_total.toFixed(2);

                                // self.tax = 0;
                                self.total_tax = 0;
                                self.total_tax.toFixed(2);

                                self.total = 0;
                                self.showTotalSummary = false;

                            } else{
                                self.$router.push("/invoice/list");
                            }

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[4])
                        {
                            $("#CreatePermitInvoiceBtn").val("Update");
                            $("#CreatePermitInvoiceBtn").prop("disabled", false);
                            $("#cancelPermitInvoiceBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#CreatePermitInvoiceBtn").prop("disabled", false);
                                $("#cancelPermitInvoiceBtn").prop("disabled",false);

                            } else{

                                $("#CreatePermitInvoiceBtn").val("Save");
                                $("#CreatePermitInvoiceBtn").prop("disabled", false);
                                $("#cancelPermitInvoiceBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'hvut-invoice-create');
                    }
                });
            }else{
                self.errorValidationFocus();
            }
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        loadHVUTInvoiceData(){
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoice/hvut",
                type: "POST",
                headers: this.ajxHeaders,
                data: {processed_hvut_schedule_id:self.processed_hvut_schedule_id},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if (data.content != undefined && data.content != null) {
                            
                            self.customer_id = data.content.customer_id;
                            self.customer = data.content.customer_code + " | " + data.content.customer_name;
                            self.invoice_type_id = {text:data.content.invoice_type_name + " (" + data.content.invoice_type_code + ")",value:data.content.invoice_type_id }

                            if (data.content.term_id != "" && data.content.term_id != null) {
                                self.term_id = {text:data.content.term_name + " (" + data.content.term_code + ")",value:data.content.term_id}
                            }else{
                                self.term_id = "";
                            }

                            self.invoice_date = data.content.invoice_date;

                            if (data.content.due_date != "" && data.content.due_date != null) {

                                self.due_date = data.content.due_date;
                            }else{

                                self.due_date = "";
                            }
                            self.location_id = data.content.location_id;
                            self.location = {text:data.content.locationName + " (" + data.content.locationCode + ")",value:data.content.location_id };
                            self.sub_total = data.content.total_before_tax;
                            self.total_tax = data.content.total_tax;
                            self.total = data.content.total;
                            
                            self.rows = [];

                            if ( data.content.items.length > 0 ) {
                                                               
                                for (var i = 0; i < data.content.items.length ; i++ ) {

                                    self.unit_no = data.content.items[i].unit_no;
                                    self.gross_weight = data.content.items[i].gross_weight;
                                    self.hvut_id = data.content.items[i].hvut_id;

                                    self.rows.push({
                                        invoice_item_id:0,
                                        process_hvut_schedule_id:self.processed_hvut_schedule_id,
                                        unit_no:data.content.items[i].unit_no,
                                        hvut_id:data.content.items[i].hvut_id,
                                        gross_weight:data.content.items[i].gross_weight,
                                        description:data.content.items[i].description,
                                        effective_date:data.content.items[i].effective_date,
                                        expiry_date:data.content.items[i].expiry_date,
                                        amount:data.content.items[i].amount,
                                        description_error_msg:"",
                                        account:"",
                                        account_error_msg:"",
                                    });
                                }
                                

                            }else{
                                self.rows = [];
                            }
                            self.disableField = true;
                            if ( self.rows.length > 0) {
                                self.showTotalSummary = true;
                            }else{
                                self.showTotalSummary = false;
                            }
                        }
                    }                     

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'hvut-invoice-data');
                }
            });
        },
        loadHVUTInvoice(){
            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/invoice-hvut/view",
                type: "GET",
                headers: this.ajxHeaders,
                data: {invoice_id:self.invoiceId},
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if (data.content != undefined && data.content != null) {

                            self.processed_hvut_schedule_id = data.content.processed_hvut_schedule_id;

                            self.invoice_number = data.content.invoice_number;
                            self.customer_id = data.content.customer_id;
                            self.customer = data.content.customer;
                            self.emails = data.content.customer_email;
                            self.invoice_type_id = {text:data.content.invoice_type_name + " (" + data.content.invoice_type_code + ")",value:data.content.invoice_type_id }

                            if (data.content.term_id != "" && data.content.term_id != null) {
                                self.term_id = {text:data.content.term_name + " (" + data.content.term_code + ")",value:data.content.term_id}
                            }else{
                                self.term_id = "";
                            }
                            if (self.isCredit == true){
                                self.invoice_date = self.getTodayDate();
                                if (data.content.termqty != undefined && data.content.term_period !=  undefined && data.content.term_period != null && data.content.term_period != ''){
                                    // self.due_date = moment(self.invoice_date).add(data.content.termqty + ', "'+data.content.term_period.toLowerCase()+'"').format('MM/DD/YYYY');
                                    self.due_date = moment(self.invoice_date, "MM/DD/YYYY").add(data.content.termqty, data.content.term_period.toLowerCase());
                                }
                            }else{
                                self.invoice_date = data.content.invoice_date;
                                self.due_date = data.content.due_date;
                            }

                            // self.invoice_date = data.content.invoice_date;

                            // if (data.content.due_date != "" && data.content.due_date != null) {

                            //     self.due_date = data.content.due_date;
                            // }else{

                            //     self.due_date = "";
                            // }
                            self.location_id = data.content.location_id;

                            self.sub_total = self.reverseFormat(data.content.formatted_sub_total);
                            self.total_tax = self.reverseFormat(data.content.formatted_tax_amount);
                            self.total = self.reverseFormat(data.content.formatted_total);
                            
                            self.rows = [];

                            if ( data.content.items.length > 0 ) {
                                                               
                                for (var i = 0; i < data.content.items.length ; i++ ) {

                                    self.unit_no = data.content.items[i].unit_no;
                                    self.gross_weight = data.content.items[i].gross_weight;
                                    self.hvut_id = data.content.items[i].hvut_id;

                                    self.rows.push({
                                        invoice_item_id:(self.$route.query.from != undefined && self.$route.query.from == 'credit') ? 0 : data.content.items[i].id,
                                        process_hvut_schedule_id:self.processed_hvut_schedule_id,
                                        unit_no:data.content.items[i].unit_no,
                                        hvut_id:data.content.items[i].hvut_id,
                                        gross_weight:data.content.items[i].gvw,
                                        description:data.content.items[i].description,
                                        effective_date:data.content.items[i].effective_date,
                                        expiry_date:data.content.items[i].expiry_date,
                                        amount:self.reverseFormat(data.content.items[i].formatted_amount),
                                        description_error_msg:"",
                                        account:(data.content.items[i].gl_account_id != undefined && data.content.items[i].gl_account_id != null && data.content.items[i].gl_account_id != '') ? {
                                            value: data.content.items[i].gl_account_id,
                                            text: data.content.items[i].gl_account,
                                        } : "",
                                        account_error_msg:"",
                                    });
                                }
                                

                            }else{
                                self.rows = [];
                            }
                            self.disableField = true;
                            if ( self.rows.length > 0) {
                                self.showTotalSummary = true;
                            }else{
                                self.showTotalSummary = false;
                            }
                        }
                    }                     

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'hvut-invoice-detail');
                }
            });
        },
        addRow: function () {
            var self = this;
            var index= self.rows.length-1;
            var error = false;

            if (self.rows.length < 1) {

                self.rows.push({
                    invoice_item_id:0,
                    process_hvut_schedule_id:self.processed_hvut_schedule_id,
                    unit_no:self.unit_no,
                    hvut_id:self.hvut_id,
                    gross_weight:self.gross_weight,
                    description:"",
                    effective_date:"",
                    expiry_date:"",
                    amount:0,
                    description_error_msg:"",
                    account:"",
                    account_error_msg:"",
                });

            }else{

                self.rows[index].description_error_msg = "";
                self.rows[index].account_error_msg = "";
                
                if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                    self.rows[index].description_error_msg = "Description Required.";
                    error = true;
                }

                if ( self.rows[index].account == null || !self.rows[index].account.value ) {
                    self.rows[index].account_error_msg = "GL Account Required.";
                    error = true;
                }

                if (!error) {

                    self.rows.push({
                        invoice_item_id:0,
                        process_hvut_schedule_id:self.processed_hvut_schedule_id,
                        unit_no:self.unit_no,
                        hvut_id:self.hvut_id,
                        gross_weight:self.gross_weight,
                        description:"",
                        effective_date:"",
                        expiry_date:"",
                        amount:0,
                        description_error_msg:"",
                        account:"",
                        account_error_msg:"",
                    });

                }

            }
            if ( self.rows.length > 0) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        calculateTotal($event,index){
            var self = this;
            var totalBeforeTax = 0;           
            var totalTaxes = 0;
            for (var i=0;i<self.rows.length;i++) {
                var amount = 0;
                if (self.rows[i].amount == '-' || self.rows[i].amount == ''){
                    continue;
                }
                if(String(self.rows[i].amount).includes(',')){
                    amount = String(self.rows[i].amount).replace(',','');
                }else{
                    amount = self.rows[i].amount;
                }
                totalBeforeTax += parseFloat(amount);
            }

            self.sub_total = parseFloat(totalBeforeTax);

            self.total_tax = parseFloat(totalTaxes);

        },
        removeItem(index) {
            var self = this;
            if(self.rows.length > 1) {

                if (self.rows[index].invoice_item_id == 0) {
                    self.rows.splice(index, 1);
                    self.calculateTotal('',index);

                }
            }
            if ( self.rows.length > 0) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        reverseFormat:function(amt){
            var self = this;

            if (self.$route.query.from != undefined && self.$route.query.from == 'credit'){
                if (amt > 0){
                    return -amt;
                }else{
                    return amt;
                }
            }else{
                return amt;
            }
        },
        isNumberCheck: function(evt) {
            
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && charCode != 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onTermChange(e) {
            console.log("here onTermChange");
            var self = this;
            console.log("here onTermChange" , self.term_id );
            if (self.term_id != null) {
                if (self.term_id.value != null) {
                    console.log("here out null");
                    console.log("here calculateDueDate" , !self.termCall );
                    if (self.$route.params.id > 0 && !self.termCall) {
                        console.log("here 962 null");
                        return;
                    }else{
                        console.log("here calculateDueDate");
                        self.calculateDueDate();
                    }
                }
            }
        },
        onInvDateChange(e) {
            console.log("here onInvDateChange");
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.invDateCall) {
                return;
            }else{
                self.calculateDueDate();
            }
        },
        calculateDueDate(){
            console.log("here calculateDueDate");
            var self = this;
            if (self.invoice_date != null && self.invoice_date != "") {
                var isDueTerm = 0;
                if (self.term_id != null) {
                    if (self.term_id.value != null) {
                        if (self.term_id.code != undefined) {
                            if (self.term_id.code == "due") {
                                isDueTerm = 1;
                                self.due_date = self.invoice_date;
                            }
                        }
                        if (isDueTerm == 0) {
                            if (self.term_id.term != undefined) {
                                if (self.term_id.term != null) {
                                    if (self.term_id.period != null) {
                                        var date = '';
                                        if (self.term_id.period == "days") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term_id.term,'days') //replace 2 with number of days you want to add
                                        }else if (self.term_id.period == "month") {
                                            date = moment(self.invoice_date, "MM/DD/YYYY").add(self.term_id.term,'month') //replace 2 with number of days you want to add
                                        }
                                        self.due_date = date;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }    
}
</script>




// WEBPACK FOOTER //
// src/components/invoice/HvutInvoiceCreate.vue